import { ReactComponent as MenuIcon } from './menu.svg';

export default MenuIcon;
